import type { FC } from 'react';
import classNames from 'classnames';

import style from './style.scss';

interface Props {
  size?: number;
  border?: number;
  color?: string;
  className?: string;
}

const CircleLoader: FC<Props> = ({ size = 14, border = 2, color = '#C4C4C4', className }) => (
  <span
    className={classNames(style.circleLoader, className)}
    style={{
      width: size,
      height: size,
      borderWidth: border,
      // Decompose style to force border right being always transparent
      borderTopColor: color,
      borderRightColor: 'transparent',
      borderLeftColor: color,
      borderBottomColor: color
    }}
  />
);

CircleLoader.displayName = 'CircleLoader';

export default CircleLoader;
